var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAgenda = function SvgAgenda(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "37.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F0F5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.7,
    fill: "url(#a)",
    fillRule: "nonzero",
    stroke: "#BEBFCB",
    rx: 2.03
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D01E29",
    d: "M20 23.2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2zm-7 0a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2zm-7 0a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2zm21-7a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2zm-7 0a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2zm-7 0a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2zm-7 0a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2zm24-16a2 2 0 0 1 2 2v10H0v-10a2 2 0 0 1 2-2h28zM13.088 3.616v3.968c0 .256-.041.49-.124.7-.083.21-.204.39-.364.536-.16.147-.353.261-.58.344a2.243 2.243 0 0 1-.772.124c-.277 0-.521-.037-.732-.112A1.579 1.579 0 0 1 9.6 8.36a2.192 2.192 0 0 1-.2-.64l1.136-.224c.09.485.323.728.696.728a.655.655 0 0 0 .452-.168c.125-.112.188-.288.188-.528V4.592h-1.696v-.976h2.912zm4.24 5.584a.745.745 0 0 1-.532-.2.92.92 0 0 1-.268-.536h-.048a.971.971 0 0 1-.424.62c-.219.141-.488.212-.808.212-.421 0-.744-.112-.968-.336-.224-.224-.336-.52-.336-.888 0-.443.161-.772.484-.988.323-.216.761-.324 1.316-.324h.664v-.264c0-.203-.053-.364-.16-.484-.107-.12-.285-.18-.536-.18-.235 0-.421.05-.56.152a1.503 1.503 0 0 0-.344.344l-.704-.624c.17-.25.385-.447.644-.588.259-.141.61-.212 1.052-.212.597 0 1.045.13 1.344.392.299.261.448.643.448 1.144v1.84h.392v.92h-.656zm-1.64-.728a.965.965 0 0 0 .508-.128c.141-.085.212-.224.212-.416v-.496h-.576c-.464 0-.696.157-.696.472v.12c0 .155.048.268.144.34.096.072.232.108.408.108zm3.088.728V5h1.184v.712h.048c.075-.219.205-.408.392-.568.187-.16.445-.24.776-.24.432 0 .759.144.98.432.221.288.332.699.332 1.232V9.2h-1.184V6.664c0-.272-.043-.473-.128-.604-.085-.13-.237-.196-.456-.196-.096 0-.19.012-.28.036a.711.711 0 0 0-.244.116.606.606 0 0 0-.172.196.546.546 0 0 0-.064.268V9.2h-1.184z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgenda, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/agenda.95d6592a.svg";
export { ForwardRef as ReactComponent };